import { render } from "./ColorSwatch.vue?vue&type=template&id=411daedd"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__